module.exports = __webpack_public_path__ + "img/txt.3fb2b2fa.png";